// src/firebaseConfig.js
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

// Konfiguration für die primäre App (Datenbank), liest aus der .env-Datei
const dbProjectConfig = {
  apiKey: process.env.REACT_APP_DB_API_KEY,
  authDomain: process.env.REACT_APP_DB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_DB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_DB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_DB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_DB_APP_ID
}

// Konfiguration für die sekundäre App (Functions), liest aus der .env-Datei
const functionsProjectConfig = {
  apiKey: process.env.REACT_APP_FUNCTIONS_API_KEY,
  authDomain: process.env.REACT_APP_FUNCTIONS_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FUNCTIONS_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FUNCTIONS_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FUNCTIONS_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FUNCTIONS_APP_ID
}

// Initialisierung der beiden Firebase-Apps
const primaryApp = initializeApp(dbProjectConfig)
const secondaryApp = initializeApp(functionsProjectConfig, 'functionsApp')

// Export der benötigten Dienste
const db = getFirestore(primaryApp) // Firestore von der primären App
// placeOrder liegt in europe-west1. Die Region muss zum Deploy der Function passen.
const functions = getFunctions(secondaryApp, 'europe-west1')

export { db, functions }
